import { CHANGE_BREADCRUMB, LOGOUT } from '../constants/ActionTypes';

const defaultStore = {
  breadcrumbs: []
};

const breadcrumb = (state = defaultStore, action) => {
  switch (action.type) {
    case CHANGE_BREADCRUMB:
      return { ...state, breadcrumbs: action.payload };

    case LOGOUT:
      return defaultStore;

    default:
      return state;
  }
};

module.exports = breadcrumb;



// WEBPACK FOOTER //
// ./reducers/breadcrumbReducer.js